import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducer';
import { routerMiddleware } from 'react-router-redux';
import createMiddleware from './middleware/clientMiddleware';
import createLogger from 'redux-logger';

let devTools = f => f;
if (typeof window === 'object'
  && typeof window.devToolsExtension !== 'undefined') {
  devTools = window.devToolsExtension();
}


if (typeof window === 'undefined') {
  global.window = {};
}

const logger = createLogger();


export default function configureStore(initialState, history, client) {
  const middlewares = [
    applyMiddleware(thunk),
    applyMiddleware(routerMiddleware(history)),
    applyMiddleware(createMiddleware(client)),
  ];

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(applyMiddleware(logger));
    middlewares.push(devTools);
  }

  const createStoreWithMiddleware = compose(...middlewares)(createStore);

  const store = createStoreWithMiddleware(reducer, initialState);
  return store;
}



// WEBPACK FOOTER //
// ./Scripts/redux/configureStore.js